import { connect } from 'react-redux'
import MembershipPane from '../../../components/riders/createrider/membership/MembershipPane'
import * as actions from '../../../state/actions/riders'
import * as serviceActions from '../../../state/actions/services'
import { IMembershipObject, IRiderObject, IStoreState } from '../../../types'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  return {
    orgId: state.organizations.currentOrgId,
    rider: ownProps.rider,
    services: state.service.items
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    getServiceList: (type: string, orgId: string) => {
      dispatch(serviceActions.fetchServiceList(type, orgId))
    },
    saveMembership: (rider: IRiderObject, memberships: IMembershipObject[]) => {
      return dispatch(actions.updateRiderMemberships(rider, memberships))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MembershipPane)



// WEBPACK FOOTER //
// ./src/containers/riders/createrider/MembershipPane.ts